import { render, staticRenderFns } from "./DataFilter.vue?vue&type=template&id=37680583&scoped=true&"
import script from "./DataFilter.vue?vue&type=script&lang=js&"
export * from "./DataFilter.vue?vue&type=script&lang=js&"
import style0 from "./DataFilter.vue?vue&type=style&index=0&id=37680583&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37680583",
  null
  
)

export default component.exports